function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m61.648 2.3505a7.9095 7.9095 0 0 0-7.4669-2.1334l-42.668 8.9869a13.32 13.32 0 0 0-7.6082 22.617l4.5814 4.5788a2.6667 2.6667 0 0 1 0.78135 1.888v8.4482a7.9069 7.9069 0 0 0 0.80002 3.4268l-0.02133 0.01867 0.06934 0.06933a8.0002 8.0002 0 0 0 3.6321 3.6161l0.06933 0.06934 0.01867-0.02133a7.9069 7.9069 0 0 0 3.4268 0.80002h8.4482a2.6667 2.6667 0 0 1 1.8854 0.77869l4.5788 4.5788a13.235 13.235 0 0 0 9.3869 3.9281 13.464 13.464 0 0 0 4.2668-0.70402 13.155 13.155 0 0 0 8.9176-10.63l9.0136-42.761a7.9335 7.9335 0 0 0-2.1121-7.5549zm-49.385 30.283-4.5841-4.5788a7.8402 7.8402 0 0 1-1.9254-8.1975 7.9415 7.9415 0 0 1 6.6668-5.4028l42.244-8.8936-40.068 40.073v-7.3468a7.9415 7.9415 0 0 0-2.3334-5.6535zm37.257 19.12a8.0002 8.0002 0 0 1-13.571 4.5654l-4.5868-4.5868a7.9415 7.9415 0 0 0-5.6508-2.3414h-7.3468l40.073-40.06z",
    fill: "currentColor",
    style: {
      strokeWidth: 2.6667
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.4c080e1c.svg";
export { ForwardRef as ReactComponent };